import React from "react";

function getRandomItem(list: string[]): string {
  const randomIndex = Math.floor(Math.random() * list.length);
  return list[randomIndex];
}
export default getRandomItem;
